import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import topics from "../../../assets/img/topics.svg"
const ShowMoreTopics = (props) => {
  const Group = require("../../../assets/img/Featured icon.jpg");
  const closePopup = () => {
    props.HideTopics();
  }
  const Topics = props.Topics;
  const MoreTopicClick = (topicTitle, topicId,abbr) => {
    props.addSelectedTopic(topicTitle, topicId,abbr);
  };


  return (
    <div>
      <Modal show={props.showPopup} onHide={props.HideTopics}
        dialogClassName="custom-modal modal-dialog-centered">
        <Modal.Header closeButton>
          <div className="popupheader">
            <div className="mod-bor-icon" >
              <img src={topics} className="mod-icon"></img>
            </div>
            <div className="header">
              <div className="signuup">Topics</div>
              <p className="Stronger">Explore more Topics</p>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="show-popuss topics_showmore">
            {
              Topics.map((topics) => {
                return (
                  
                  <button type="button" className={props.selectedTopicId.includes(topics._id) ? "btn-lg top-links showmore-top active" : "btn-lg top-links showmore-top"}  key={topics._id} onClick={() => MoreTopicClick(topics.topicTitle, topics._id,props.getAbbreviation(topics.communityId?.communityName))}>

                    <div class="btn-group form-check form-check form-check form-check" role="group"
                      aria-label="Basic outlined example">

                     <input type="checkbox" name="payment" id={`vessels-${topics._id}`}
                        className="vesselradio form-check-input radiobtn " 
                       checked={props.selectedTopicId.includes(topics._id)}/>
                      
                      
                      <label for={`vessels-${topics._id}`}  className="showmore-radio form-check-label">{topics.topicTitle} <strong>({props.getAbbreviation(topics.communityId?.communityName)})</strong> </label>

                    </div>
                  </button>
                 
                  
                )

              })
            }



          </div>




        </Modal.Body>
        <Modal.Footer className="modal-center" >
          <Button variant="secondary" className="pop-primary" onClick={closePopup}>Close</Button>
        </Modal.Footer>

      </Modal>
    </div>
  );


};
export default ShowMoreTopics;